export const getProviderPublicProfileDomain = () => {
  if (window.location.hostname.includes('localhost')) {
    return 'http://localhost:4700';
  }

  if (window.location.hostname.includes('stage-')) {
    return 'https://stage-direct.joinuplift.co';
  }

  return 'https://direct.joinuplift.co';
};
